import { headScript, deleteScript } from '~/helpers/externals'
import Window from '~/utils/window'

// If you use this mixin, you also need to use `Recaptcha-terms` component on the page
// for legal reasons because we hide the default recaptcha icon.

const RecaptchaV3 = {
  data () {
    return {
      recaptchaUrl: `https://www.google.com/recaptcha/api.js?render=${this.$env.GOOGLE_RECAPTCHA_V3_KEY}`
    }
  },

  async mounted () {
    if (this.$env.GOOGLE_RECAPTCHA_V3_KEY) {
      await headScript(this.recaptchaUrl)
    }
  },

  methods: {
    getRecaptchaToken () {
      // Token expires after 2 minutes, this one needs to be called before submit
      const { grecaptcha } = Window

      if (this.$env.GOOGLE_RECAPTCHA_V3_KEY && grecaptcha) {
        return new Promise((resolve, reject) => {
          grecaptcha.ready(async () => {
            const token = await grecaptcha.execute(this.$env.GOOGLE_RECAPTCHA_V3_KEY)

            if (token) {
              return resolve(token)
            }

            return reject()
          })
        })
      }

      return Promise.resolve()
    }
  },

  destroyed () {
    deleteScript(this.recaptchaUrl)
  }
}

export default RecaptchaV3
